declare global {
    interface System {
      import (request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'
import { NONAME } from 'dns';
export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => System.import('../components/lockscreen/components/locking-page.vue')
};
export const autoLoginRouter = {
    path: '/autoLogin',
    name: 'autoLogin',
    meta: {title: '自动登录'},
    component:()=>System.import('../views/autoLogin.vue')
};
export const loginRouter = {
    path: '/',
    name: 'login',
    meta: {title: '登录'},
    component:()=>System.import('../views/login.vue')
};
export const otherRouters={
    path:'/main',
    name:'main',
    permission:'',
    meta:{title:'首页'},
    component:main,
    children:[
        {path: '/home', meta:{title:'首页'}, name: 'home', component:()=>System.import('../views/home/home.vue')}
    ]
}
export const appRouters=[
    {
        path:'/contract',
        name:'contract',
        permission:'Pages.CAndMManager',
        meta:{title:'合同经营管理'},
        icon:'ios-paper', 
        component:main,
        redirect:'/contract/contractList',
        children:[ 
            {
                path: 'contractList',
                permission:'Pages.CAndMManager.C', 
                meta:{title:'合同台账'}, 
                name: 'contractList', 
                component:()=>System.import('../views/contractManage/contractManage/contractList.vue')
            },
            {
                path: 'contractManage',
                permission:'Pages.CAndMManager.C', 
                meta:{title:'合同台账'}, 
                name: 'contractManage', 
                display:'none',
                component:()=>System.import('../views/contractManage/contractManage/contractManage.vue'),
                children: [
                    {
                        path: 'contractList',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:'合同台账'}, 
                        name: 'contractList', 
                        component:()=>System.import('../views/contractManage/contractManage/contractList.vue'),
                    },
                    {
                        path: 'contractAdd',
                        permission:'Pages.CAndMManager.C.Maintain', 
                        meta:{title:'合同登记',activeName:'contractList',parentPath:'contractList'}, 
                        name: 'contractAdd', 
                        component:()=>System.import('../views/contractManage/contractManage/contractAdd.vue')
                    },
                    {
                        path: 'contractDetail',
                        permission:'Pages.CAndMManager.C.ViewDetailInfo', 
                        meta:{title:'主合同详情',activeName:'contractList',parentPath:'contractList'}, 
                        name: 'contractDetail', 
                        component:()=>System.import('../views/contractManage/contractManage/contractDetail.vue')
                    },
                    {
                        path: 'contractDetailMoney',
                        permission:'Pages.CAndMManager.C.RView', 
                        meta:{title:'收款与资质管理费计提情况'}, 
                        name: 'contractDetailMoney', 
                        component:()=>System.import('../views/contractManage/contractManage/contractDetailMoney.vue')
                    },
                    {
                        path: 'contractDetailStatus',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:'倒排工期与合同执行情况'}, 
                        name: 'contractDetailStatus', 
                        component:()=>System.import('../views/contractManage/contractManage/contractDetailStatus.vue')
                    },
                    {
                        path: 'contractSpecialList',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:'特殊合同台账',activeName:'contractList',parentPath:'contractSpecialList'}, 
                        name: 'contractSpecialList', 
                        display: 'none',
                        component:()=>System.import('../views/contractManage/contractManage/contractSpecialList.vue')
                    },
                    {
                        path: 'contractSpecialDetail',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:'特殊合同详情',activeName:'contractList',parentPath:'contractSpecialList'}, 
                        name: 'contractSpecialDetail', 
                        component:()=>System.import('../views/contractManage/contractManage/contractSpecialDetail.vue')
                    },
                    {
                        path: 'contractAddAgreementList',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:'补充协议台账',activeName:'contractList',parentPath:'contractAddAgreementList'}, 
                        display: 'none',
                        name: 'contractAddAgreementList', 
                        component:()=>System.import('../views/contractManage/contractManage/contractAddAgreementList.vue')
                    },
                    {
                        path: 'contractAddAgreementDetail',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:'主合同补充协议详情',activeName:'contractList',parentPath:'contractAddAgreementList'}, 
                        name: 'contractAddAgreementDetail', 
                        component:()=>System.import('../views/contractManage/contractManage/contractAddAgreementDetail.vue')
                    },
                    {
                        path: 'contractOutsideAgreementDetail',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:'外协合同补充协议详情',activeName:'contractList',parentPath:'contractAddAgreementList'}, 
                        name: 'contractOutsideAgreementDetail', 
                        component:()=>System.import('../views/contractManage/contractManage/contractOutsideAgreementDetail.vue')
                    },
                    {
                        path: 'contractOutsideList',
                        permission:'Pages.CAndMManager.C.EView', 
                        meta:{title:'外协合同台账',activeName:'contractList',parentPath:'contractOutsideList'}, 
                        name: 'contractOutsideList', 
                        display: 'none',
                        component:()=>System.import('../views/contractManage/contractManage/contractOutsideList.vue')
                    },
                    {
                        path: 'contractOutsideDetail',
                        permission:'Pages.CAndMManager.C.EView', 
                        meta:{title:'外协合同详情',activeName:'contractList',parentPath:'contractOutsideList'}, 
                        name: 'contractOutsideDetail', 
                        component:()=>System.import('../views/contractManage/contractManage/contractOutsideDetail.vue')
                    },
                    {
                        path: 'contractOutsideDetailMoney',
                        permission:'Pages.CAndMManager.C.EView', 
                        meta:{title:'外协合同详情-付款情况',activeName:'contractList',parentPath:'contractOutsideList'}, 
                        name: 'contractOutsideDetailMoney', 
                        component:()=>System.import('../views/contractManage/contractManage/contractOutsideDetailMoney.vue')
                    },
                    {
                        path: 'blank',
                        permission:'Pages.CAndMManager.C', 
                        meta:{title:''}, 
                        name: '', 
                    }
                ]
            },
            {
                path: 'contractStatus',
                permission:'Pages.QAndSManager.ProjectM', 
                meta:{title:'合同执行情况'}, 
                name: 'contractStatus', 
                component:()=>System.import('../views/contractManage/contractManage/contractStatus.vue')
            },
            {
                path: 'yearCountContract',
                permission:'Pages.CAndMManager.Statistic', 
                meta:{title:'年度合同登记情况统计'}, 
                name: 'yearCountContract', 
                component:()=>System.import('../views/contractManage/contractCount/yearCount.vue')
            },
            {
                path: 'outsideUnitManage',
                permission:'Pages.CAndMManager.ExternalUnit', 
                meta: {title:'外协单位管理'}, 
                name: 'outsideUnitManage',
                component:()=>System.import('../views/contractManage/outsideUnitManage.vue')
            },
            // {
            //     path: 'licenseManage',
            //     permission:'Pages.CAndMManager.Permit', 
            //     meta: {title:'证照借用管理'}, 
            //     name: 'licenseManage',
            //     component:()=>System.import('../views/contractManage/licenseManage.vue')
            // },
            // {
            //     path: 'monthReportManage',
            //     permission:'Pages.CAndMManager', 
            //     meta: {title:'月报管理'}, 
            //     name: 'monthReportManage',
            //     component:()=>System.import('../views/contractManage/monthReportManage.vue')
            // },
            // {
            //     path: 'tenderManage',
            //     permission:'Pages.CAndMManager.TenderingM', 
            //     meta: {title:'招投标管理'}, 
            //     name: 'tenderManage',
            //     component:()=>System.import('../views/contractManage/tenderManage.vue')
            // },
            {
                path: 'blank',
                permission:'Pages.CAndMManager', 
                meta:{title:''}, 
                name: '', 
            }
        ]
    },
    {
        path: '/qualitySafeManage',
        name:'qualitySafeManage',
        permission:'Pages.QAndSManager',
        meta:{title:'项目管理'},
        icon:'social-buffer',
        component: main,
        redirect:'/qualitySafeManage/projectList',
        children: [
            // {
            //     path: 'affairManage',
            //     permission:'Pages.QAndSManager.DaliyM', 
            //     meta:{title:'总工办日常事务管理'}, 
            //     name: 'affairManage', 
            //     component:()=>System.import('../views/qualitySafeManage/affairManage/affairManage.vue'),
            //     children: [
            //         {
            //             path: 'personManage',
            //             permission:'Pages.QSM.PersonM.QSDep', 
            //             meta:{title:'人员管理'}, 
            //             name: 'personManage', 
            //             display: 'none',
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/personManage/personManage.vue'),
            //         },
            //         {
            //             path: 'letterOfCommitment',
            //             permission:'Pages.QSM.PersonM.Commitment', 
            //             meta:{title:'承诺书管理'}, 
            //             name: 'letterOfCommitment', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/personManage/letterOfCommitment.vue'),
            //         },
            //         {
            //             path: 'docManage',
            //             permission:'Pages.QSM.MatterM', 
            //             meta:{title:'文件或事项管理'}, 
            //             name: 'docManage', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/docManage/docManage.vue'),
            //         },
            //         {
            //             path: 'docManageDetail/:id',
            //             permission:'Pages.QSM.MatterM', 
            //             meta:{title:'文件或事项管理-详情'}, 
            //             name: 'docManageDetail',
            //             display: 'none',
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/docManage/docManageDetail.vue'),
            //         },
            //         {
            //             path: 'trainManage',
            //             permission:'Pages.QSM.TrainM', 
            //             meta:{title:'教育培训管理'}, 
            //             name: 'trainManage', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/trainManage/trainManage.vue')
            //         },
            //         {
            //             path: 'instituteManage',
            //             permission:'Pages.QSM.InstituteM', 
            //             meta:{title:'制度管理'}, 
            //             name: 'instituteManage', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/instituteManage/instituteManage.vue')
            //         },
            //         {
            //             path: 'safeBooksManage',
            //             permission:'Pages.SafetyM', 
            //             meta:{title:'安全管理台账'}, 
            //             name: 'safeBooksManage', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/safeBooksManage/safeBooksManage.vue')
            //         },
            //         {
            //             path: 'secretManage',
            //             permission:'Pages.SafetyM', 
            //             meta:{title:'涉密管理'}, 
            //             name: 'secretManage', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/secretManage/secretManage.vue')
            //         },
            //         {
            //             path: 'dangerChemicalManage',
            //             permission:'Pages.SafetyM', 
            //             meta:{title:'危化品管理'}, 
            //             name: 'dangerChemicalManage', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/dangerChemical/index.vue')
            //         },
            //         {
            //             path: 'internalAuditsCost',
            //             permission:'Pages.SafetyM', 
            //             meta:{title:'内审费管理'}, 
            //             name: 'internalAuditsCost', 
            //             component:()=>System.import('../views/qualitySafeManage/affairManage/internalAuditsCost/index.vue')
            //         },
            //         // {
            //         //     path: 'businessApplyManage',
            //         //     permission:'Pages.SafetyM', 
            //         //     meta:{title:'业务申请管理'}, 
            //         //     name: 'businessApplyManage', 
            //         //     component:()=>System.import('../views/qualitySafeManage/affairManage/businessApply/index.vue')
            //         // },
            //         // {
            //         //     path: 'weeklyManage',
            //         //     permission:'Pages.SafetyM', 
            //         //     meta:{title:'周报管理'}, 
            //         //     name: 'weeklyManage', 
            //         //     component:()=>System.import('../views/qualitySafeManage/affairManage/weeklyManage/index.vue')
            //         // },
            //         // {
            //         //     path: 'examineWork',
            //         //     permission:'Pages.SafetyM', 
            //         //     meta:{title:'考核工作'}, 
            //         //     name: 'examineWork', 
            //         //     component:()=>System.import('../views/qualitySafeManage/affairManage/examineWork/index.vue')
            //         // }
            //     ]
            // },
            {
                path: 'projectList',
                permission:'Pages.QAndSManager.ProjectM', 
                meta:{title:'项目台账'}, 
                name: 'projectList', 
                component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectList.vue')
            },
            {
                path: 'newProjectManage',
                permission:'Pages.QAndSManager.ProjectM', 
                meta:{title:'总工办项目管理',parentPath:'projectList'}, 
                name: 'newProjectManage', 
                display: 'none',
                component:()=>System.import('../views/qualitySafeManage/projectManage/newProjectManage.vue'),
                children: [
                    // {
                    //     path: 'declareManage',
                    //     permission:'Pages.QAndSManager.ProjectM.ViewList', 
                    //     meta:{title:'项目立项申报管理'}, 
                    //     name: 'declareManage', 
                    //     component:()=>System.import('../views/qualitySafeManage/projectManage/declareManage.vue')
                    // },
                    {
                        path: 'projectList',
                        permission:'Pages.QAndSManager.ProjectM', 
                        meta:{title:'新开项目基本信息填报'}, 
                        name: 'projectList', 
                        component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectList.vue')
                    },
                    {
                        path: 'projectTime',
                        permission:'Pages.QAndSManager.ProjectM', 
                        meta:{title:'进度管理',activeName:'projectList',parentPath:'projectTime'}, 
                        name: 'projectTime', 
                        component:()=>System.import('../views/qualitySafeManage/projectManage/projectTime/projectTime.vue')
                    },
                    {
                        path: 'qualityManage',
                        permission:'Pages.QAndSManager.ProjectM', 
                        meta:{title:'质量过程管理',activeName:'projectList',parentPath:'qualityManage'}, 
                        name: 'qualityManage', 
                        component:()=>System.import('../views/qualitySafeManage/projectManage/qualityManage/qualityManage.vue')
                    },
                    {
                        path: 'safeManage',
                        permission:'Pages.QAndSManager.Security.ViewList', 
                        meta:{title:'安全过程管理',activeName:'projectList',parentPath:'safeManage'}, 
                        name: 'safeManage', 
                        component:()=>System.import('../views/qualitySafeManage/projectManage/safeManage/safeManage.vue')
                    },
                    {
                        path: 'projectDetail',
                        permission:'Pages.QAndSManager.ProjectM.ViewBaseInfo', 
                        meta:{title:'项目详情',activeName:'projectList',parentPath:'projectList'},
                        name: 'projectDetail',
                        component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/projectDetail.vue')
                    },                    
                    {
                        path: 'projectAdd',
                        permission:'Pages.QAndSManager.ProjectM.Add', 
                        meta:{title:'项目填报',activeName:'projectList'},
                        name: 'projectAdd',
                        component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectAdd.vue')
                    }
                ]
            },
            {
                path: 'projectCount',
                permission:'Pages.QAndSManager.ProjectM.Stage', 
                meta:{title:'项目阶段统计'}, 
                name: 'projectCount', 
                component:()=>System.import('../views/qualitySafeManage/countReport/projectCount.vue')
            },
            {
                path: 'contractCount',
                permission:'Pages_QAndSManager_ProjectM_CAndPS', 
                meta:{title:'合同与项目统计分析'}, 
                name: 'contractCount', 
                component:()=>System.import('../views/qualitySafeManage/countReport/contractCount.vue')
            },   
            {
                path: 'fundsExcel',
                permission:'Pages.QAndSManager.ProjectM.FinanceStat', 
                meta:{title:'资金统计分析'}, 
                name: 'fundsExcel', 
                component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/financeList/fundsExcel.vue')
            },  
            {
                path: 'workFee',
                permission:'Pages.QAndSManager.ProjectM.TechWorkFeeStat', 
                meta:{title:'技术工作费结算清单'}, 
                name: 'workFee', 
                component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/financeList/workFee.vue')
            }, 
            {
                path: 'landFundsExcel',
                permission:'Pages.QAndSManager.ProjectM.FinanceStatGT', 
                meta:{title:'资金统计分析'}, 
                name: 'landFundsExcel', 
                component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/landFinance/fundsExcel.vue')
            },  
            {
                path: 'landWorkFee',
                permission:'Pages.QAndSManager.ProjectM.TechWorkFeeStatGT', 
                meta:{title:'技术工作费结算清单'}, 
                name: 'landWorkFee', 
                component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/landFinance/workFee.vue')
            },  
            {
                path: 'yearCount',
                permission:'Pages.QAndSManager.ProjectM.PFinanceStatOne', 
                meta:{title:'项目财务统计'}, 
                name: 'yearCount', 
                component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/oneFinance/yearCount.vue')
            },
            {
                path: 'countReport',
                permission:'Pages.QAndSManager.ProjectM.Stage', 
                meta:{title:'统计报表'}, 
                name: 'countReport', 
                display: 'none',
                component:()=>System.import('../views/qualitySafeManage/countReport/countReport.vue'),
                children:[
                    // {
                    //     path: 'projectCount',
                    //     permission:'Pages.QAndSManager.ProjectM.Stage', 
                    //     meta:{title:'项目阶段统计'}, 
                    //     name: 'projectCount', 
                    //     component:()=>System.import('../views/qualitySafeManage/countReport/projectCount.vue')
                    // },
                    // {
                    //     path: 'contractCount',
                    //     permission:'Pages_QAndSManager_ProjectM_CAndPS', 
                    //     meta:{title:'合同与项目统计分析'}, 
                    //     name: 'contractCount', 
                    //     component:()=>System.import('../views/qualitySafeManage/countReport/contractCount.vue')
                    // },   
                    // {
                    //     path: 'fundsExcel',
                    //     permission:'Pages.QAndSManager.ProjectM.FinanceStat', 
                    //     meta:{title:'资金统计分析'}, 
                    //     name: 'fundsExcel', 
                    //     component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/financeList/fundsExcel.vue')
                    // },  
                    // {
                    //     path: 'workFee',
                    //     permission:'Pages.QAndSManager.ProjectM.TechWorkFeeStat', 
                    //     meta:{title:'技术工作费结算清单'}, 
                    //     name: 'workFee', 
                    //     component:()=>System.import('../views/qualitySafeManage/projectManage/projectList/projectDetail/financeList/workFee.vue')
                    // },        
                    {
                        path: 'blank',
                        permission:'Functions.Password', 
                        meta:{title:''}, 
                        name: '', 
                    }
                ]
            },
            {
                path: 'blank',
                permission:'Pages.QAndSManager', 
                meta:{title:''}, 
                name: '', 
            }
        ]
    },
    {
        path: '/affairManage',
        permission:'Pages.QAndSManager.DaliyM', 
        meta:{title:'总工办日常事务'}, 
        icon:'ios-book', 
        display: 'none',
        name: 'affairManage', 
        // component:()=>System.import('../views/qualitySafeManage/affairManage/affairManage.vue'),
        component:main,
        children: [
            {
                path: 'personManage',
                permission:'Pages.QSM.PersonM.QSDep', 
                meta:{title:'人员管理'}, 
                name: 'personManage', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/personManage/personManage.vue'),
            },
            {
                path: 'letterOfCommitment',
                permission:'Pages.QSM.PersonM.Commitment', 
                meta:{title:'承诺书管理'}, 
                name: 'letterOfCommitment', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/personManage/letterOfCommitment.vue'),
            },
            {
                path: 'docManage',
                permission:'Pages.QSM.MatterM', 
                meta:{title:'文件或事项管理'}, 
                name: 'docManage', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/docManage/docManage.vue'),
            },
            {
                path: 'docManageDetail/:id',
                permission:'Pages.QSM.MatterM', 
                meta:{title:'文件或事项管理-详情'}, 
                name: 'docManageDetail',
                display: 'none',
                component:()=>System.import('../views/qualitySafeManage/affairManage/docManage/docManageDetail.vue'),
            },
            {
                path: 'trainManage',
                permission:'Pages.QSM.TrainM', 
                meta:{title:'教育培训管理'}, 
                name: 'trainManage', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/trainManage/trainManage.vue')
            },
            {
                path: 'instituteManage',
                permission:'Pages.QSM.InstituteM', 
                meta:{title:'制度管理'}, 
                name: 'instituteManage', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/instituteManage/instituteManage.vue')
            },
            {
                path: 'safeBooksManage',
                permission:'Pages.SafetyM', 
                meta:{title:'安全管理台账'}, 
                name: 'safeBooksManage', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/safeBooksManage/safeBooksManage.vue')
            },
            {
                path: 'secretManage',
                permission:'Pages.SafetyM', 
                meta:{title:'涉密管理'}, 
                name: 'secretManage', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/secretManage/secretManage.vue')
            },
            {
                path: 'dangerChemicalManage',
                permission:'Pages.SafetyM', 
                meta:{title:'危化品管理'}, 
                name: 'dangerChemicalManage', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/dangerChemical/index.vue')
            },
            {
                path: 'internalAuditsCost',
                permission:'Pages.SafetyM', 
                meta:{title:'内审费管理'}, 
                name: 'internalAuditsCost', 
                component:()=>System.import('../views/qualitySafeManage/affairManage/internalAuditsCost/index.vue')
            },
            // {
            //     path: 'businessApplyManage',
            //     permission:'Pages.SafetyM', 
            //     meta:{title:'业务申请管理'}, 
            //     name: 'businessApplyManage', 
            //     component:()=>System.import('../views/qualitySafeManage/affairManage/businessApply/index.vue')
            // },
            // {
            //     path: 'weeklyManage',
            //     permission:'Pages.SafetyM', 
            //     meta:{title:'周报管理'}, 
            //     name: 'weeklyManage', 
            //     component:()=>System.import('../views/qualitySafeManage/affairManage/weeklyManage/index.vue')
            // },
            // {
            //     path: 'examineWork',
            //     permission:'Pages.SafetyM', 
            //     meta:{title:'考核工作'}, 
            //     name: 'examineWork', 
            //     component:()=>System.import('../views/qualitySafeManage/affairManage/examineWork/index.vue')
            // }
        ]
    },
    {
        path:'/ky',
        name:'ky',
        permission:'Pages.RM',
        meta:{title:'科研管理'},
        icon:'university',
        component:main,
        redirect:'/ky/scientficProject',
        children:[
            {
                path: 'scientficProject',
                permission:'Pages.RM', 
                meta:{title:'科研项目'}, 
                name: 'scientficProject', 
                component:()=>System.import('../views/scientificManage/scientficProject/scientficProjectList.vue'),
            },
            {
                path: 'scientficProjectAdd',
                permission:'Pages.RM', 
                meta:{title:'科研项目登记'}, 
                name: 'scientficProjectAdd', 
                component:()=>System.import('../views/scientificManage/scientficProject/scientficProjectAdd.vue'),
            },
            {
                path: 'scientficProjectDetail',
                permission:'Pages.RM',
                meta:{title:'科研项目详情'},
                name: 'scientficProjectDetail', 
                component:()=>System.import('../views/scientificManage/scientficProject/scientficProjectDetail/scientficProjectDetail.vue'),
            },
            // {
            //     path: 'specialProject',
            //     permission:'Pages.SM', 
            //     meta:{title:'创新引导项目管理'}, 
            //     name: 'specialProject', 
            //     component:()=>System.import('../views/scientificManage/specialProject/specialProjectManage.vue'),
            //     children: [
            //         {
            //             path: 'specialProjectList',
            //             permission:'Pages.SM', 
            //             meta:{title:'创新引导项目台账'},
            //             name: 'specialProjectList', 
            //             component:()=>System.import('../views/scientificManage/specialProject/specialProjectList.vue'),
            //         },
            //         {
            //             path: 'specialProjectDetail',
            //             permission:'Pages.SM.PViewDetail',
            //             meta:{title:'创新引导项目详情'},
            //             name: 'specialProjectDetail', 
            //             component:()=>System.import('../views/scientificManage/specialProject/specialProjectDetail/specialProjectDetail.vue'),
            //         },
            //         {
            //             path: 'blank',
            //             permission:'Pages.SM', 
            //             meta:{title:''}, 
            //             name: '', 
            //         }
            //     ]
            // },
            {
                path: 'specialProjectList',
                permission:'Pages.SM', 
                meta:{title:'创新引导项目'},
                name: 'specialProjectList', 
                component:()=>System.import('../views/scientificManage/specialProject/specialProjectList.vue'),
            },
            {
                path: 'specialProjectAdd',
                permission:'Pages.SM',
                meta:{title:'创新引导项目登记'},
                name: 'specialProjectAdd', 
                component:()=>System.import('../views/scientificManage/specialProject/specialProjectAdd.vue'),
            },
            {
                path: 'specialProjectDetail',
                permission:'Pages.SM.PViewDetail',
                meta:{title:'创新引导项目详情'},
                name: 'specialProjectDetail', 
                component:()=>System.import('../views/scientificManage/specialProject/specialProjectDetail/specialProjectDetail.vue'),
            },
            {
                path: 'achieveManage',
                permission:'Pages.AM.Achieve', 
                meta:{title:'科研成果'},
                name: 'achieveManage', 
                component:()=>System.import('../views/scientificManage/achieveManage/achieveManage.vue'),
            },
            {
                path: 'paperManage',
                permission:'Pages.AM.Achieve', 
                meta:{title:'论文管理',activeName:'achieveManage'},
                name: 'paperManage', 
                display: 'none',
                component:()=>System.import('../views/scientificManage/achieveManage/paperManage.vue'),
            },
            {
                path: 'patentManage',
                permission:'Pages.AM.Achieve', 
                meta:{title:'专利管理',activeName:'achieveManage'},
                name: 'patentManage', 
                display: 'none',
                component:()=>System.import('../views/scientificManage/achieveManage/patentManage.vue'),
            },
            {
                path: 'monographManage',
                permission:'Pages.AM.Achieve', 
                meta:{title:'专著管理',activeName:'achieveManage'},
                name: 'monographManage', 
                display: 'none',
                component:()=>System.import('../views/scientificManage/achieveManage/monographManage.vue'),
            },
            {
                path: 'standardManage',
                permission:'Pages.AM.Achieve', 
                meta:{title:'标准管理',activeName:'achieveManage'},
                name: 'standardManage', 
                display: 'none',
                component:()=>System.import('../views/scientificManage/achieveManage/standardManage.vue'),
            },
            {
                path: 'awardPrizeManage',
                permission:'Pages.AM.Achieve', 
                meta:{title:'获奖管理',activeName:'achieveManage'},
                name: 'awardPrizeManage', 
                display: 'none',
                component:()=>System.import('../views/scientificManage/achieveManage/awardPrizeManage.vue'),
            },
            {
                path: 'academic',
                permission:'Pages.AM.Academic', 
                meta:{title:'学术活动'}, 
                name: 'academic', 
                component:()=>System.import('../views/scientificManage/academic/academic.vue')
            },
            {
                path: 'personnel',
                permission:'Pages.AM.Academic', 
                meta:{title:'名号人才'}, 
                name: 'personnel', 
                component:()=>System.import('../views/scientificManage/personnel/personnel.vue')
            },
            {
                path: 'scientificSystem',
                permission:'Pages.AM.Academic', 
                meta:{title:'科研制度'}, 
                name: 'scientificSystem', 
                component:()=>System.import('../views/scientificManage/scientificSystem/scientificSystem.vue'),
                // children: [
                //     {
                //         path: 'scientificSystem',
                //         permission:'Pages.AM.Achieve', 
                //         meta:{title:'科研制度'},
                //         name: 'scientificSystem', 
                //         component:()=>System.import('../views/scientificManage/scientificSystem/scientificSystem.vue'),
                //     },
                //     {
                //         path: 'projectTemplate',
                //         permission:'Pages.AM.Achieve', 
                //         meta:{title:'项目模板'},
                //         name: 'projectTemplate', 
                //         component:()=>System.import('../views/scientificManage/scientificSystem/projectTemplate.vue'),
                //     },
                //     {
                //         path: 'blank',
                //         permission:'Pages.AM.Achieve', 
                //         meta:{title:''}, 
                //         name: '', 
                //     }
                // ]
            },
            {
                path: 'projectTemplate',
                permission:'Pages.PTM', 
                meta:{title:'项目模板'},
                name: 'projectTemplate', 
                component:()=>System.import('../views/scientificManage/scientificSystem/projectTemplate.vue'),
            },
            // {
            //     path: 'scientificInfo',
            //     permission:'Pages.AM.Academic', 
            //     meta:{title:'科研项目信息公示'}, 
            //     name: 'scientificInfo', 
            //     component:()=>System.import('../views/scientificManage/learningManage/learningManage.vue')
            // },
            {
                path: 'blank',
                permission:'Pages.RM', 
                meta:{title:''}, 
                name: '', 
            }
        ]
    },
    // {
    //     path:'/usedDocManage',
    //     name:'usedDocManage',
    //     permission:'Pages.CommonDoc',
    //     meta:{title:'常用文档管理'},
    //     icon:'document-text',
    //     component:main,
    //     children:[ 
    //         {path: 'docList',permission:'Pages.CommonDoc', meta:{title:'文档列表'}, name: 'docList', component:()=>System.import('../views/usedDocManage/usedDocList.vue')}
    //     ]
    // },
    {
        path:'/workflow',
        name:'workflow',
        permission:'Pages.WFManager',
        meta:{title:'流程管理'},
        icon:'shuffle',
        component:main,
        redirect:'/workflow/backlogList',
        children:[ 
            {path: 'backlogList',permission:'Pages_WFManager_Monitor', meta:{title:'流程监控'}, name: 'backlogList', component:()=>System.import('../views/workflow/backlogList.vue')},
            {path: 'backlogWait',permission:'Pages_WFManager_Waiting', meta:{title:'待办流程'}, name: 'backlogWait', component:()=>System.import('../views/workflow/backlogWait.vue')},
            {path: 'backlogDetail',permission:'Pages_WFManager_Execute', meta:{title:'流程详情'}, name: 'backlogDetail', component:()=>System.import('../views/workflow/backlogDetail.vue')},
        ]
    },
    // {
    //     path:'/notice',
    //     name:'notice',
    //     permission:'Pages.CommonDoc',
    //     meta:{title:'通知公告'},
    //     icon:'document-text',
    //     component:main,
    //     children:[ 
    //         {
    //             path: 'noticeList',
    //             permission:'Pages.CommonDoc', 
    //             meta:{title:'通知列表'}, 
    //             name: 'noticeList', 
    //             component:()=>System.import('../views/notice/noticeList.vue')
    //         },
    //         {
    //             path: 'addNotice',
    //             permission:'Pages.CommonDoc', 
    //             meta:{title:'发布通知'}, 
    //             name: 'addNotice', 
    //             component:()=>System.import('../views/notice/addNotice.vue')
    //         },
    //     ]
    // },
    {
        path:'/message',
        name:'message',
        permission:'Functions.Password',
        meta:{title:'消息管理'},
        icon:'document-text',
        component:main,
        display: 'none',
        children:[ 
            {
                path: 'messageList',
                permission:'Functions.Password', 
                meta:{title:'消息列表'}, 
                name: 'messageList', 
                component:()=>System.import('../views/message/messageList.vue')
            },          
            {
                path: 'blank',
                permission:'Functions.Password', 
                meta:{title:''}, 
                name: '', 
            }
        ]
    },
    // {
    //     path:'/query',
    //     name:'query',
    //     permission:'',
    //     meta:{title:'综合查询'},
    //     icon:'ios-search-strong',
    //     component:main,
    //     children:[ 
    //         {path: 'user',permission:'Pages.Users', meta:{title:'综合查询'}, name: 'qy', component:()=>System.import('../views/setting/user/user.vue')},
    //     ]
    // },
    {
        path:'/setting',
        name:'setting',
        permission: 'Functions.Password',
        meta:{title:'系统设置'},
        icon:'ios-gear',
        component:main,
        redirect:'/setting/user',
        children:[
            {path: 'user',permission:'Pages.Users', meta:{title:'用户管理'}, name: 'user', component:()=>System.import('../views/setting/user/user.vue')},
            {path: 'role',permission:'Pages.Roles', meta:{title:'角色管理'}, name: 'role', component:()=>System.import('../views/setting/role/role.vue')},            
            {
                path: 'myData',
                permission:'Functions.Password', 
                meta:{title:'我的资料'}, 
                name: 'myData', 
                display: 'none',
                component:()=>System.import('../views/personal/myData.vue')
            },
            {
                path: 'account',
                permission:'Functions.Password', 
                meta:{title:'修改密码'}, 
                name: 'account', 
                display: 'none',
                component:()=>System.import('../views/personal/account.vue')
            },          
            {
                path: 'blank',
                permission:'Functions.Password', 
                meta:{title:''}, 
                name: '', 
            }
        ]
    }
]
export const routers = [
    loginRouter,
    autoLoginRouter,
    locking,
    ...appRouters,
    otherRouters
];
